import DevChampsResultTokenRs from '@domain/rs/dchamps/DevChampsResultTokenRs';

export default class DevChampsResultTokenVO {
  iframeUrl: string;

  constructor(rs: DevChampsResultTokenRs) {
    this.iframeUrl = `${rs.url}/report/jobda?token=${rs.token}`;
  }
}
